import { render } from "./PhoneMaskComponent.vue?vue&type=template&id=574cc922"
import script from "./PhoneMaskComponent.vue?vue&type=script&lang=js"
export * from "./PhoneMaskComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__